import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex } from "sprout-ui-primitives";
import { useMemo } from "react";
import { ItemMemberLevel } from "sprout-graphql";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import styled from "styled-components";
import { media } from "sprout-ui-theme";
import { useSetGoBackURL } from "@sprout/providers/dist/goBack";
import useGoUp from "@sprout/hooks/dist/useGoUp";
import useTopicPageShortcuts from "../TopicPage/useTopicPageShortcuts";
import { PostPageProvider } from "./PostPageContext";
import { PostPageEditorProvider } from "./PostPageEditorContext";
import { PostPageFocusProvider } from "./PostPageFocusContext";
import { PostPageViewModeProvider } from "./PostPageViewModeContext";
const MaxWidthWrapper = styled(Flex)`
  ${media.up("medium", "pointer")} {
    padding: 32px 16px 16px;
  }
`;
const PostPagePage = (props)=>{
    const { main , item , toolbar , goBackURL , obscure  } = props;
    const { rootTopicOrSelf , owner  } = item;
    const currentUser = useCurrentUser();
    const initialValue = useMemo(()=>{
        let authorized = false;
        if (rootTopicOrSelf) {
            const { memberLevel  } = rootTopicOrSelf;
            // https://github.com/sproutio/sprout/issues/284
            authorized = memberLevel && [
                ItemMemberLevel.Owner,
                ItemMemberLevel.Admin
            ].includes(memberLevel) || memberLevel === ItemMemberLevel.Contributor && (owner === null || owner === void 0 ? void 0 : owner.id) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
        } else authorized = false;
        return {
            authorized,
            /**
       * We allow `watch`/`label` and `comments` and will disable
       * everything else
       */ disabled: !authorized || item.deletedAt !== null || item.archivedAt !== null
        };
    }, [
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.id,
        item.archivedAt,
        item.deletedAt,
        owner === null || owner === void 0 ? void 0 : owner.id,
        rootTopicOrSelf, 
    ]);
    useSetGoBackURL(goBackURL);
    useGoUp(goBackURL);
    const rootOwner = rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.owner;
    useTopicPageShortcuts({
        owner: rootOwner,
        topic: rootTopicOrSelf
    });
    return /*#__PURE__*/ _jsx(PostPageProvider, {
        initialState: initialValue,
        children: /*#__PURE__*/ _jsx(PostPageEditorProvider, {
            children: /*#__PURE__*/ _jsx(PostPageFocusProvider, {
                children: /*#__PURE__*/ _jsx(PostPageViewModeProvider, {
                    initialState: initialValue.authorized ? "EDIT" : "VIEW",
                    children: /*#__PURE__*/ _jsxs(MaxWidthWrapper, {
                        flexDirection: "column",
                        flex: "1 0 auto",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                maxWidth: 1080,
                                width: "100%",
                                pb: 3,
                                children: main
                            }),
                            toolbar,
                            obscure
                        ]
                    })
                })
            })
        })
    });
};
export default PostPagePage;
